const pathUtils = {
  getContextPath: function (path) {
    path = path || ''
    if (!path || path.startsWith('/')) {
      let getContextPath = window['getContextPath']
      if (getContextPath) {
        return getContextPath() + path
      }
    }
    return path
  }
}

export default pathUtils
